export const FIREFOX =
  'https://addons.mozilla.org/firefox/addon/pulse-start-page-new-tab/'
export const CHROME =
  'https://chrome.google.com/webstore/detail/pulse-async-new-tab/gljkncabelmmkdehkhnlklmhjompjkbh'

export default {
  FIREFOX,
  CHROME,
}
